import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import Slider from "react-slick";
import { compose } from "redux";
import Card from "./Card";

const PublicSlideshow = (props) => {
  const [data, setData] = useState([]);
  const [dataOrder, setDataOrder] = useState([]);
  const [images, setImages] = useState([]);
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  // Getting Data From Props to save it in the State
  useEffect(() => {
    setData(props.slideshow);
  }, [props.slideshow]);
  useEffect(() => {
    setDataOrder(props.slideshowOrder);
  }, [props.slideshowOrder]);

  useEffect(() => {
    const order = dataOrder?.order?.order;
    if (order && order.length > 0) {
      let storingObject = Object.keys(data);
      let imagesArray = [];
      if (storingObject.length > 0) {
        imagesArray = order.map((key) => {
          return data[key];
        });
      }
      setImages(imagesArray);
    } else setImages([]);
  }, [data, dataOrder]);

  const settingsForMain = {
    // infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
  };
  const settingsForUndermain = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    autoplay: false,
    autoplaySpeed: 2500,
    lazyLoad: "ondemand",
  };
  return (
    <div>
      <Slider
        className="about-slide-show"
        asNavFor={nav2}
        ref={(slider1) => setNav1(slider1)}
        {...settingsForMain}
      >
        {images.map((image) => {
          return <Card image={image} />;
        })}
      </Slider>
      <Slider
        // infinite={images.length < 4 ? false : true}
        className="about-slide-show2"
        asNavFor={nav1}
        ref={(slider2) => setNav2(slider2)}
        {...settingsForUndermain}
      >
        {images.map((image) => {
          return <Card image={image} />;
        })}
      </Slider>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    slideshow: state.firestore.data.slideshow,
    slideshowOrder: state.firestore.data.slideshowOrder,
    superAdmin: state.auth.superAdmin,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "slideshow",
    },
    {
      collection: "slideshowOrder",
    },
  ])
)(PublicSlideshow);
